import { memo } from "react";
import { classNames } from "helpers";
import { formatDateParam } from "helpers/common";
import CalendarEvent from "../CalendarEvent/CalendarEvent";
import { DAYS_OF_WEEK, MONTH_CELL_VISIBLE_EVENTS } from "../../consts";
import { MonthGridProps } from "../../types";

const MonthGrid: React.FC<MonthGridProps> = (props) => {
  const { weeks, month, itemsByDate, selectedDate, onDayClick } = props;

  const todayKey = formatDateParam(new Date());

  return (
    <div>
      <div className="grid grid-cols-7 border-b border-slate-200">
        {DAYS_OF_WEEK.map((day) => (
          <div
            key={day}
            className="text-center text-xs font-medium text-gray-500 py-2 border-r border-slate-100 last:border-r-0"
          >
            {day}
          </div>
        ))}
      </div>

      <div>
        {weeks.map((week, weekIndex) => (
          <div
            key={weekIndex}
            className="grid grid-cols-7 border-b border-slate-100 last:border-b-0"
          >
            {week.map((day) => {
              const key = formatDateParam(day)!;
              const items = itemsByDate.get(key) ?? [];
              const visible = items.slice(0, MONTH_CELL_VISIBLE_EVENTS);
              const hiddenCount = items.length - visible.length;

              const isToday = key === todayKey;
              const isOtherMonth = day.getMonth() !== month;

              const handleClick = () => onDayClick(day);

              return (
                <div
                  key={key}
                  onClick={handleClick}
                  className={classNames(
                    // `min-w-0` je nužan: ćelija mreže se inače ne smije suziti ispod svog
                    // sadržaja, pa bi dugi naslov razvukao cijeli stupac.
                    "min-w-0 overflow-hidden min-h-[110px] p-1.5 border-r border-slate-100 last:border-r-0 cursor-pointer transition-colors",
                    isOtherMonth ? "bg-slate-50/60" : "hover:bg-slate-50",
                    selectedDate === key ? "bg-sky-50/70" : ""
                  )}
                >
                  <div className="flex justify-end mb-1">
                    <span
                      className={classNames(
                        "w-6 h-6 flex items-center justify-center rounded-full text-xs font-semibold",
                        isToday
                          ? "bg-sky-600 text-white"
                          : isOtherMonth
                            ? "text-gray-400"
                            : "text-gray-700"
                      )}
                    >
                      {day.getDate()}
                    </span>
                  </div>

                  <div className="space-y-1">
                    {visible.map((item, index) => (
                      <CalendarEvent key={`${item.id}-${index}`} item={item} />
                    ))}
                    {hiddenCount > 0 && (
                      <div className="text-[11px] font-medium text-gray-500 px-2">
                        +{hiddenCount}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(MonthGrid);
